import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'

import * as Styled from './styled'
import { getIsOperationSystemMacOs } from 'utils/operation-system'
import { T } from 'consts/translationKeys'
import { Icon } from 'common-components'
import UndoIcon from 'assets/svgr-icons/Undo.svg'
import RedoIcon from 'assets/svgr-icons/Redo.svg'
import Tooltip from 'components/Tooltip'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { useKeyPressWithConfigs } from 'hooks'
import { translate } from 'utils/translations'

export const UndoRedo: React.FC = () => {
  const undoCount = useSelector(projectDataSelectors.undoCount)
  const redoCount = useSelector(projectDataSelectors.redoCount)

  const undoAction = () => {
    dispatch(projectDataThunks.undo())
  }

  const redoAction = () => {
    dispatch(projectDataThunks.redo())
  }

  // Keyboard shortcuts for undo/redo
  useKeyPressWithConfigs('z', undoAction, { configs: { metaKey: true } })
  useKeyPressWithConfigs('z', redoAction, {
    configs: { metaKey: true, shiftKey: true }
  })

  const undoActionRef = useRef<HTMLDivElement | null>(null)
  const redoActionRef = useRef<HTMLDivElement | null>(null)

  const isOperationSystemMacOs = getIsOperationSystemMacOs()

  return (
    <Styled.UndoRedoWrapper $isDisable={false}>
      <Tooltip
        tooltipText={`${translate(T.UNDO)} (${isOperationSystemMacOs ? '⌘' : 'Ctrl'} Z)`}
        position="bottom"
      >
        <Styled.UndoRedoAction
          data-qa="undo-action"
          $isActive={!!undoCount}
          ref={undoActionRef}
          onClick={undoAction}
        >
          <Icon icon={<UndoIcon />} customSize={20} />
        </Styled.UndoRedoAction>
      </Tooltip>

      <Tooltip
        tooltipText={`${translate(T.REDO)} (Shift ${
          isOperationSystemMacOs ? '⌘' : 'Ctrl'
        } Z)`}
        position="bottom"
      >
        <Styled.UndoRedoAction
          data-qa="redo-action"
          $isActive={!!redoCount}
          ref={redoActionRef}
          onClick={redoAction}
        >
          <Icon icon={<RedoIcon />} customSize={20} />
        </Styled.UndoRedoAction>
      </Tooltip>
    </Styled.UndoRedoWrapper>
  )
}
